import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import { initializeApp} from 'firebase/app'
import { Api } from './api.js'
import AppProvider from './components/AppProvider.vue'

import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import './styles/admin.css'

initializeApp({
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID
});

const api = new Api({
  api_url: process.env.VUE_APP_API_URL
})

const app = createApp(App)
  .use(ElementPlus)
  .use(router)
  .use(api)

app.component('app-provider', AppProvider)
  
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.mount('#app')
